"use client";

import React from "react";

interface IProps {
  data: any;
  messagePrefix?: string
}

export default function DummyClientConsoleComp({ data, messagePrefix }: IProps) {
  console.log(messagePrefix ?? "dummy", { data });
  return <></>;
}
